// Copyright (c) Docugami, Inc. All rights reserved.

export enum ComponentId {
    Control = 0,
    Bounds,
    Color,
    RootControl, // Tag
    CursorHit,
    Selected,
    Hover, // Tag
    Resize,
    ChunkRender,
    TableChunkRender,
    Drag,
    Grabber,
    Interactable,
    Position,
    TokenPosition,
    SnapToToken,
    Cursor,
    Renderable, // Tag
    TokenRange,
    Svg,
    FocusView,
    Highlighter,
    ExternalRender,
    ChunkDrag,
    ChunkSelector,
    SimpleTable, // Tag
    SimpleTableColumnHeader,
    TableColumnRender, // Tag
    SearchState,
    TokenRangeInfo,
    Hyperline, // Tag
    TokenLines,
    Table, // Tag
    TableCell, // Tag
    TableRow, // Tag
    BreakHyperline,
    TableChunkSelector,
    Outline,
    SelectionContext,
    Image,
    AddedChunk, // Tag
    EphemeralSelection, // Tag
    TextEditor,
    EditTextSelectionComponent, // Tag
    TokenRender,
    View,
    Outflow, // Tag
    OutflowRender,
    Overlay,
    Default, // Tag
    Active, // Tag
    PreviewChunk, // Tag
    MultiSelect, // Tag
}

export interface Component {
    typeId: ComponentId;
}

export type ComponentMap = {[id: string]: Component}

export type ComponentProps<T extends Component> = Omit<T, "typeId">;

export function tagComponent(componentId: ComponentId): Component {
    return {
        typeId: componentId
    }
}
